import React, { useEffect, useState } from "react";
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Button,
  Avatar,
  Flex,
  Box,
  Text,
  HStack,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { FaUserEdit } from "react-icons/fa";
import { useSelector } from "react-redux";
import { updateProfile } from "../services/updateUser";

const PasswordField = ({ id, label, value, onChange }) => {
  const [show, setShow] = useState(false);
  return (
    <FormControl>
      <FormLabel htmlFor={id} color={"#9B9B9B"} fontWeight={400} fontSize={"16px"}>
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          id={id}
          type={show ? "text" : "password"}
          bg={"#FFFFFF"}
          h={"45px"}
          fontWeight={"semibold"}
          value={value}
          onChange={onChange}
        />
        <InputRightElement h={"45px"}>
          <IconButton
            variant="ghost"
            size="sm"
            aria-label={show ? "Hide password" : "Show password"}
            icon={show ? <ViewOffIcon /> : <ViewIcon />}
            onClick={() => setShow((v) => !v)}
          />
        </InputRightElement>
      </InputGroup>
    </FormControl>
  );
};

export const EditProfileModal = ({ userProfile, setRefresh }) => {
  const pageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const userId = useSelector((state) => state.auth.userId);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(() => userProfile?.name);
  const [phoneNumber, setPhoneNumber] = useState(
    () => userProfile?.phoneNumber
  );
  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  // This modal mounts as part of the Profile page's tree immediately, well
  // before userProfile finishes loading from the API — the useState
  // initializers above capture whatever it was at that moment (usually
  // undefined) and, being plain useState, never revisit it. Without this,
  // Name/Phone Number render blank every time the modal is opened, and
  // submitting without first manually retyping both (easy to miss — the
  // fields look pre-filled-but-empty, not obviously wrong) fails
  // server-side validation instead of saving. Re-sync from the current
  // profile every time the modal opens.
  useEffect(() => {
    if (isOpen) {
      setName(userProfile?.name ?? "");
      setPhoneNumber(userProfile?.phoneNumber ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, userProfile]);

  const [confirmPassword, setConfirmPassword] = useState(
    userProfile?.confirmPassword
  );
  const [image, setImage] = useState(()=>userProfile?.image);
  const [file, setFile] = useState();


  const handleUpdateProfile = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("name", name)
    formData.append("phoneNumber", phoneNumber)
    formData.append("password", newPassword)
    formData.append("confirmPassword", confirmPassword)
    formData.append("oldPassword", oldPassword)
    formData.append("profileImage", image)

    // const payload = {
    //   name,
    //   phoneNumber,
    //   newPassword,
    //   confirmPassword,
    //   oldPassword
    // }
   
    await updateProfile(userId, formData, setLoading, setRefresh, onClose);
  };

  return (
    <>
      <FaUserEdit
        cursor="pointer"
        color={pageColor}
        size={50}
        onClick={onOpen}
        // ref={finalRef}
      />

      <Modal
        // initialFocusRef={finalRef}
        // finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size="3xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton color="gray" />
          <ModalBody pb={6} mb="30px">
            <Flex
              direction={["column", "column", "row"]}
              p={["10px 10px 0 10px", "10px 10px 0 10px", "50px 50px 0 50px"]}
            >
              <Flex
                align={["center", "center", "flex-start"]}
                justify={["center", "center", "flex-start"]}
              >
                <Box position={"relative"} cursor={"pointer"}>
                  <Avatar
                    size={"2xl"}
                    name={name}
                    src={file || image}
                    alt={`Profile image of ${name}`}
                  />
                  {/* <input
                    className="photo"
                    type="file"
                    name="file"
                    onChange={(e) => {
                      setImage(e?.target?.files?.[0]);
                      setFile(URL.createObjectURL(e?.target?.files?.[0]));
                    }}
                  /> */}
                  {/* <Text color={"#264653"} fontWeight={"semibold"} mt="10px">
                    Change Image
                  </Text> */}
                </Box>
              </Flex>
              <Box
                pl={["0", "0", "50px"]}
                w={["100%", "100%", "100%"]}
                pt={["40px", "40px", "0"]}
              >
                <Text
                  color={"#264653"}
                  fontSize={"22px"}
                  fontWeight={"bold"}
                  pb={"10px"}
                  textAlign={["center", "center", "start"]}
                >
                  Edit User Profile
                </Text>
                <HStack spacing={[6, 6, 12]} mb={"20px"}>
                  <FormControl>
                    <FormLabel
                      color={"#9B9B9B"}
                      fontWeight={400}
                      fontSize={"16px"}
                    >
                      Name
                    </FormLabel>
                    <Input
                      type="text"
                      bg={"#FFFFFF"}
                      h={"45px"}
                      value={name}
                      fontWeight={"semibold"}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel
                      color={"#9B9B9B"}
                      fontWeight={400}
                      fontSize={"16px"}
                    >
                      Phone Number
                    </FormLabel>
                    <Input
                      type="tel"
                      bg={"#FFFFFF"}
                      h={"45px"}
                      fontWeight={"semibold"}
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </FormControl>
                </HStack>

                <Text
                  color={"#264653"}
                  fontSize={"22px"}
                  fontWeight={"bold"}
                  pb={"10px"}
                  textAlign={["center", "center", "start"]}
                >
                  Change Password
                </Text>
                <HStack spacing={[6, 6, 12]} mb={"20px"}>
                  <PasswordField
                    id="new-password"
                    label="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <PasswordField
                    id="confirm-password"
                    label="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </HStack>

                <HStack spacing={[6, 6, 12]}>
                  <PasswordField
                    id="old-password"
                    label="Old password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                  <Box>
                    <Button
                      bg={pageColor}
                      color="#FCFBFE"
                      size={"lg"}
                      fontWeight="medium"
                      px={"70px"}
                      py={"10px"}
                      mt="30px"
                      _hover={{bg: pageColor}}
                      rounded="lg"
                      //justify={"flex-end"}
                      isLoading={loading}
                      onClick={handleUpdateProfile}
                    >
                      Submit
                    </Button>
                  </Box>
                </HStack>
              </Box>
            </Flex>
          </ModalBody>

        </ModalContent>
      </Modal>
    </>
  );
};
